import { useEffect } from 'react';
import { robotint } from '../components/robotint';
import { TRobotintConfig } from '../types/robotint-config.type';
import { TTintColor } from '../types/tint-color.type';
import { PATH_TO_LOAD_ROBOTINT_SCRIPT } from '../consts/tint-service.consts';
import { setRobotintOptions } from '../helpers/set-robotint-options.helper';

type TProps = {
  robotintConfig: TRobotintConfig;
  handleSelectColor: (color: Required<TTintColor>) => void;
  productId: string | undefined;
};

export const useRobotintScript = ({ robotintConfig, handleSelectColor, productId }: TProps) => {
  const { robotintLink } = robotintConfig;

  useEffect(() => {
    const isScriptAddedToPage =
      document.querySelector(`script[src="${robotintLink}${PATH_TO_LOAD_ROBOTINT_SCRIPT}"]`) !== null;
    if (!isScriptAddedToPage && robotintLink.length > 0) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `${robotintLink}${PATH_TO_LOAD_ROBOTINT_SCRIPT}`;
      script.onload = () => {
        import('../components/web-components');

        setRobotintOptions({ robotintConfig, handleSelectColor });
      };
      document.body.append(script);
    } else if (isScriptAddedToPage && robotintLink.length > 0) {
      setRobotintOptions({ robotintConfig, handleSelectColor });
    }
  });

  useEffect(() => {
    robotint.enableButtons();
  }, [productId]);

  useEffect(() => {
    window.addEventListener('resize', robotint.enableButtons);

    return () => window.removeEventListener('resize', robotint.enableButtons);
  }, []);
};
